import { render, staticRenderFns } from "./passenger-editor.vue?vue&type=template&id=391a6b1b&"
import script from "./passenger-editor.vue?vue&type=script&lang=js&"
export * from "./passenger-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports